<div class="overlay" *ngIf="isLoading">
    <div class="loader-content">
      <!-- <img src="assets/images/buildcraft.png" alt="Loader Image" class="loader-image" /> -->
      <div class="spinner"></div>
    </div>
  </div>